import { FC, HTMLAttributes, useState, memo } from 'react';
import cn from 'classnames';

import styles from './ClipboardCopy.module.css';

export interface ClipboardCopyProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  copyText: string;
}

const ClipboardCopy: FC<ClipboardCopyProps> = ({ className, copyText, ...restProps }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(copyText);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1500);
  };

  return (
    <div {...restProps} className={cn(styles.copy, className)}>
      <input
        className={cn(styles.promoCode, { [styles.isCopied]: isCopied }, className)}
        onClick={handleCopyClick}
        type='button'
        value={isCopied ? 'Скопировано в буфер' : copyText}
      />
    </div>
  );
};

export default memo(ClipboardCopy);
